import Links from '@/shared/constants/navegacao';
import ModelEditarMaximoEstagiarios from './ModelEditarMaximoEstagiarios';
import { ApiReturn } from '@/modules/api.service';
import { Column, DataTable } from '@/shared/components/tables/DataTable';
import { GetNucleos, UpdateNucleoMaxEstagiarios, } from '@/modules/structure/nucleo/nucleo.service';
import { Link } from 'react-router-dom';
import { ReadComarcaDto, ReadNucleoDto } from '@/api.types';
import { readComarca } from '@/modules/structure/comarca/comarca.service';
import { toast } from 'react-toastify';
import { useDataTableState } from '@/shared/components/tables/useDataTableState';
import { useBreadcrumbActions } from '@/shared/contexts/BreadcrumbActionsContext';
import { useEffect, useState } from 'react';

export default function NucleoIndexPage() {
  const { setActions } = useBreadcrumbActions();
  const [registros, setRegistros] = useState<ApiReturn<ReadNucleoDto>>();
  const tableState = useDataTableState('nome');

  const [showModal, setShowModal] = useState(false);
  const [initialValue, setInitialValue] = useState<number>(0);
  const [editId, setEditId] = useState<number>();

  const [comarcas, setComarcas] = useState<ReadComarcaDto[]>([]);
  const [comarcaid, setComarcaId] = useState<number>(0);

  useEffect(() => {
    readComarca({ skip: 0, take: 1000, orderBy: 'ASC', orderField: 'nome' })
      .then((result) => {
        setComarcas(result[0]);
      })
      .catch((res) => {
        toast.error((res as string) + '');
      });
  }, []);

  useEffect(() => {
    handleBuscar();
  }, [comarcaid]);

  useEffect(() => {
    setActions({ primary: { label: 'Cadastrar', href: Links.Nucleo_Criar, onClick: () => { } } });
    return () => setActions({});
  }, [setActions]);

  const handleBuscar = () => {
    GetNucleos(
      (tableState.currentPage - 1) * tableState.pageSize,
      tableState.pageSize,
      comarcaid,
      tableState.filter,
    )
      .then((result) => {
        setRegistros(result);
      })
      .catch((res) => {
        toast.error(String(res) || '');
      });
  };

  function handleAplicar(newValue: number): void {
    if (editId) {
      UpdateNucleoMaxEstagiarios(editId, newValue)
        .then(() => {
          toast.success('Número de estagiários atualizado.');
          const r = registros?.objects.find((a) => a.id === editId);
          if (r) r.maximoIntegrantes = newValue;
          setShowModal(false);
        })
        .catch((res) => {
          toast.error((res as string) + '');
        });
    }
  }

  let colunas: Column<ReadNucleoDto>[] = [
    { key: "ordem", header: "Ordem" },
    { key: "nome", header: "Nome" },
    { key: "comarca.nome", header: "Comarca" },
    { key: "predio.nome", header: "Unidade" },
    { key: "diretoria.nome", header: "Diretoria" },
    {
      key: "lotacoes", header: "Lotações", render: (row) =>
        <Link className="link-secondary" to={Links.Vinculos_Index + '?tipo=defensor&nucleoid=' + row.id}>
          {row.lotacoes?.length}
        </Link>
    },
    {
      key: "maximoIntegrantes", header: "Max. Estagiários", render: (row) =>
        <button
          className="btn p-0"
          onClick={() => {
            setEditId(row.id);
            setInitialValue(row.maximoIntegrantes);
            setShowModal(true);
          }}>
          {row.maximoIntegrantes}
        </button>
    },
    {
      key: "acoes", header: "Ações", render: (row) =>
        <Link className="link-secondary" to={Links.Nucleo_Editar + '/' + row.id}>
          Editar
        </Link>
    },
  ];

  return (
    <>
      <div className="row">
        <div className="col-12">
          <h3 className="pt-4">Núcleos</h3>
          <span className="blockquote-footer pb-4 text-end">
            Núcleos cadastrados no sistema.
          </span>
        </div>

        <hr className="pb-4" />

        {registros &&
          <DataTable
            columns={colunas}
            data={registros.objects}
            initialSortKey="nome"
            onChange={handleBuscar}
            serverSide={true}
            states={tableState}
            totalRecords={registros.count}
            renderFilters={() => (
              <div className='row ms-2'>
                <div className="col-md-12">
                  <select
                    title="Comarca"
                    className="form-select"
                    id="comarca"
                    name="comarca"
                    onChange={(e: React.ChangeEvent<HTMLSelectElement>) =>
                      setComarcaId(e.target.value as unknown as number)
                    }
                  >
                    <option value={0}>(todas as comarcas)</option>
                    {comarcas !== undefined &&
                      comarcas !== null &&
                      comarcas.map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.nome}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
            )}
          />
        }
      </div>
      <ModelEditarMaximoEstagiarios
        show={showModal}
        initialValue={initialValue}
        handleHide={() => {
          setShowModal(false);
        }}
        handleAplicar={handleAplicar}
      />
    </>
  );
}